import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/utils';

const FormInput = ({
  startIcon,
  endIcon,
  onEndIconClick,
  name,
  description,
  placeholder,
  label,
  className,
  ...rest
}) => {
  const form = useFormContext();

  const handleEndIconClick = () => {
    if (onEndIconClick) {
      onEndIconClick();
    }
  };

  return (
    <div className={cn('mb-4', className)}>
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {label && <FormLabel>{label}</FormLabel>}
            <FormControl>
              <div className="relative">
                {startIcon && (
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    {startIcon}
                  </div>
                )}
                <Input
                  placeholder={placeholder}
                  className={cn(
                    startIcon ? 'pl-10' : '',
                    endIcon ? 'pr-10' : ''
                  )}
                  {...field}
                  {...rest}
                />
                {endIcon && (
                  <div
                    className={cn(
                      'absolute inset-y-0 right-0 flex items-center pr-3',
                      onEndIconClick ? 'cursor-pointer' : 'pointer-events-none'
                    )}
                    onClick={handleEndIconClick}
                  >
                    {endIcon}
                  </div>
                )}
              </div>
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default FormInput;
